<template>
  <div class="hp-manager-page-list">
    <standard-table ref="datas" size="default" :bordered="true" :columns="columns" :indentSize="15" :dataSource="datas" :pagination="false" :loading="loading" @tableChange="tableChange">
    </standard-table>
  </div>
</template>

<script>
import { api } from "@/common";

import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import config from "@/config";
import { setTimeout } from "timers";

export default {
  mixins: [account, dateFormat, moneyFormat],
  // 接受属性
  props: {
    paramsX: Object
  },
  data() {
    return {
      filter: [],
      columns: [
        {
          title: "产品编码",
          dataIndex: "productCode",
          width: 110,
          sorter: true
        },
        {
          title: "产品名称",
          dataIndex: "productName",
          width: 300,
          sorter: true
        },
        {
          title: "规格属性",
          dataIndex: "specDes"
        },
        {
          title: "数量",
          dataIndex: "quantity",
          width: 100
        }
      ],
      datas: [],
      filterdata: Object.assign(JSON.parse(JSON.stringify(config.pageFilter))),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      addVisible: false,
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      productId: 0
    };
  },
  async mounted() {
    this.productId = this.paramsX.id;
    this.getDatas();
  },
  methods: {
    handleSubmit(p) {
      this.getDatas();
    },

    refreshCurrent() {
      this.getDatas();
    },
    tableChange(table) {
      this.getDatas();
    },

    async getDatas() {
      this.loading = true;
      let data = await api.GetProductPackageList({ productId: this.productId });
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/Goods/Product/PackageList.vue